import { useIsAuthenticated, useMsal } from '@azure/msal-react'
import { AppButton } from '@components/AppButton'
import { loginRequestApi } from '@utils/authConfig.ts'
import { useTranslations } from '@utils/i18n-to-migrate/useTranslations'
import { LogInIcon, LogOutIcon } from 'lucide-react'
import { forwardRef } from 'react'

export const LoginButton = forwardRef<HTMLButtonElement>((props, ref) => {
  const { instance } = useMsal()
  const { t } = useTranslations()
  const isAuthenticated = useIsAuthenticated()

  const handleLogin = () => {
    instance.loginRedirect({ ...loginRequestApi }).catch((e: unknown) => {
      console.error(`loginRedirect failed: ${e}`)
    })
  }

  const handleLogout = async () => {
    try {
      await instance.logoutRedirect({
        postLogoutRedirectUri: '/',
      })
    } catch (error) {
      console.error('Logout failed:', error)
    }
  }

  return isAuthenticated ? (
    <AppButton
      ref={ref}
      variant="default"
      className="w-50"
      onClick={() => {
        void handleLogout()
      }}
      {...props}
    >
      <LogOutIcon />
      {t('general.logOut')}
    </AppButton>
  ) : (
    <AppButton
      ref={ref}
      variant="default"
      className="w-50"
      onClick={() => {
        handleLogin()
      }}
      {...props}
    >
      <LogInIcon />
      {t('general.logIn')}
    </AppButton>
  )
})

LoginButton.displayName = 'LoginButton'
